/**
 * Lupe-Icon + Lightbox fuer ShopPad Infinite-Options Swatches.
 * - Faengt App-Init via MutationObserver ab (App rendert async).
 * - Fuegt pro Swatch ein Lupe-Button hinzu (oben rechts).
 * - Klick auf Lupe oeffnet natives <dialog> mit grossem Bild + Farbname.
 * - Klick auf Swatch selbst bleibt unveraendert (Farbe auswaehlen).
 */
(function () {
  'use strict';

  const SWATCH_WRAPPER = '.spb-productoptionswatchwrapper';
  const SWATCH_IMG = '.spb-productoptionswatch';
  const SWATCH_LABEL = '.spb-swatchlabel';
  const MARKER = 'data-sp-lupe-ready';
  const SVG_NS = 'http://www.w3.org/2000/svg';

  function extractBgUrl(el) {
    const bg = el.style.backgroundImage || '';
    const m = bg.match(/url\(["']?([^"')]+)["']?\)/);
    return m ? m[1] : null;
  }

  function makeLupeSvg() {
    const svg = document.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '2.2');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    svg.setAttribute('aria-hidden', 'true');
    const circle = document.createElementNS(SVG_NS, 'circle');
    circle.setAttribute('cx', '11');
    circle.setAttribute('cy', '11');
    circle.setAttribute('r', '7');
    const line = document.createElementNS(SVG_NS, 'line');
    line.setAttribute('x1', '16.5');
    line.setAttribute('y1', '16.5');
    line.setAttribute('x2', '21');
    line.setAttribute('y2', '21');
    svg.append(circle, line);
    return svg;
  }

  let dialogEl = null;
  function getDialog() {
    if (dialogEl) return dialogEl;
    dialogEl = document.createElement('dialog');
    dialogEl.className = 'sp-lupe-dialog';
    const closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'sp-lupe-close';
    closeBtn.setAttribute('aria-label', 'Schließen');
    closeBtn.textContent = '×';
    const img = document.createElement('img');
    img.className = 'sp-lupe-image';
    img.alt = '';
    const caption = document.createElement('p');
    caption.className = 'sp-lupe-label';
    dialogEl.append(closeBtn, img, caption);
    closeBtn.addEventListener('click', () => dialogEl.close());
    dialogEl.addEventListener('click', (e) => {
      if (e.target === dialogEl) dialogEl.close();
    });
    document.body.appendChild(dialogEl);
    return dialogEl;
  }

  function openLightbox(wrapper) {
    const imgEl = wrapper.querySelector(SWATCH_IMG);
    const labelEl = wrapper.querySelector(SWATCH_LABEL);
    const url = imgEl ? extractBgUrl(imgEl) : null;
    if (!url) return;
    const name = labelEl ? labelEl.textContent.trim() : '';
    const d = getDialog();
    d.querySelector('.sp-lupe-image').src = url;
    d.querySelector('.sp-lupe-image').alt = name;
    d.querySelector('.sp-lupe-label').textContent = name;
    d.showModal();
  }

  function addLupeButton(wrapper) {
    if (wrapper.hasAttribute(MARKER)) return;
    const imgEl = wrapper.querySelector(SWATCH_IMG);
    if (!imgEl || !extractBgUrl(imgEl)) {
      wrapper.setAttribute(MARKER, '');
      return;
    }
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'sp-lupe-btn';
    btn.setAttribute('aria-label', 'Vergrößern');
    btn.appendChild(makeLupeSvg());
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      openLightbox(wrapper);
    });
    wrapper.appendChild(btn);
    wrapper.setAttribute(MARKER, '');
  }

  function scan(root) {
    (root || document).querySelectorAll(SWATCH_WRAPPER).forEach(addLupeButton);
  }

  function start() {
    scan();
    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        for (const n of m.addedNodes) {
          if (n.nodeType !== 1) continue;
          if (n.matches && n.matches(SWATCH_WRAPPER)) addLupeButton(n);
          if (n.querySelectorAll) scan(n);
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
